import React from "react";
import {SearchForm} from "./searchForm";
import ServiceItemsList from "./serviceItemsList";
const ServiceItems = () => {
    return (
        <>
            <SearchForm/>
            <ServiceItemsList/>
        </>
        // <div>bill-supplier</div>
    )
}
export default ServiceItems